import React from 'react';
import { FlatList, Image } from 'react-native';
import type { AccountProps } from '../../types';
import AccountCard from './AccountCard';
import { Icons } from '../../Components';
import { Button, Text, View } from '../../Components/Themed';
import { useColors } from '../../constants/useColors';

type AccountManagerProps = {
    accounts:AccountProps[],
    onClose:() => void,
    onSelectAccount: (account:AccountProps) => void
    onSelectManualACH: () => void,
    onSelectManualCard: () => void,
    onSelectInstantBankTransfer: () => void
}
const screen_sections = ['header','my_accounts','new_account']

const AccountManager = ({ accounts,  onSelectAccount, onSelectManualACH, onSelectManualCard, onSelectInstantBankTransfer , onClose}:AccountManagerProps) => {
    const Colors = useColors();
    const my_accounts = accounts.filter(a => !a.ibt_placeholder && !['bettoredge'].includes(a.account_type))
    //const ibt_placeholder = accounts.find(a => a.ibt_placeholder);

    const renderAccounts = (data:{item:AccountProps, index:number}) => {
        return (
            <View transparent style={{ margin:5 }}>
                <AccountCard
                    account={data.item}
                    onSelectAccount={(account) => onSelectAccount(account)}
                />
            </View>
        )
    }

    const renderSections = (data:{item:string, index:number}) => {
        switch(data.item){
            case 'header':
                return (
                    <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:15 }}>
                        <View transparent style={{flex:1}}>
                            <Text size={20} theme='h1'>MANAGE MY ACCOUNTS</Text>
                            <Text style={{ marginTop:5}} theme='description'>Below are the accounts we have on file for you.  Please select one to manage or transact!</Text>
                        </View>
                    </View>
                )
            case 'my_accounts':
                return (
                    <View style={{ marginTop:10 }}>
                        <View type='header' style={{ padding:20, flexDirection:'row', alignItems:'center' }}>
                            <View transparent style={{ flex:1 }}>
                                <Text theme='h1'>MY ACCOUNTS</Text>
                                <Text style={{ marginTop:3 }} theme='description'>Accounts already linked or ways to transact immediately</Text>
                            </View>
                        </View>
                        <View type='body' style={{ padding:20 }}>
                            <FlatList
                                data={my_accounts}
                                renderItem={renderAccounts}
                                keyExtractor={(item) => item.account_id.toString()}
                            />
                        </View>
                    </View>
                )
            case 'new_account':
                return (
                    <View>
                        <View type='header' style={{ padding:20, flexDirection:'row', alignItems:'center' }}>
                            <View transparent style={{ flex:1 }}>
                                <Text theme='h1' color={Colors.text.success}>ADD NEW ACCOUNT</Text>
                                <Text style={{ marginTop:3 }} theme='description'>Link a new account and use to transact</Text>
                            </View>
                        </View>
                        <View type='body' style={{ padding:20 }}>
                            <Button float style={{ marginTop:10, padding:5, flexDirection:'row', alignItems:'center' }}
                            onPress={() => onSelectInstantBankTransfer()}>
                                <View  style={{  height:50, width:80, borderRadius:8, justifyContent:'center', alignItems:'center', borderWidth:1, borderColor:Colors.absolutes.brand.cobalt }}>
                                    <Image
                                        source={{ uri: 'https://res.cloudinary.com/hoabts6mc/image/upload/v1695821528/1630344814441_wjq98b.png' }}
                                        style={{ width:50, height:30 }}
                                        resizeMode='cover'
                                    />
                                </View>
                                <View transparent style={{ flex:1, marginLeft:10 }}>
                                    <Text size={10} color={Colors.text.success} weight='bold'>RECOMMENDED</Text>
                                    <Text size={14} theme='h1' textAlign='left'>INSTANT BANK TRANSFER</Text>
                                </View>
                            </Button>
                            <Button float style={{ marginTop:10, padding:5, flexDirection:'row', alignItems:'center' }}
                            onPress={() => onSelectManualACH()}>
                                <View float style={{  height:50, width:50, justifyContent:'center', alignItems:'center' }}>
                                    <Icons.BankIcon size={22} color={Colors.text.h1} />
                                </View>
                                <View transparent style={{ flex:1, marginLeft:10 }}>
                                    <Text size={14} theme='h2' textAlign='left'>ADD MANUAL ACH ACCOUNT</Text>
                                </View>
                            </Button>
                            <Button float style={{ marginTop:10, padding:5, flexDirection:'row', alignItems:'center' }}
                            onPress={() => onSelectManualCard()}>
                            <View float style={{  height:50, width:50, justifyContent:'center', alignItems:'center'}}>
                                <Icons.CreditCardIcon size={22} color={Colors.text.highlight} />
                            </View>
                            <View transparent style={{ flex:1, marginLeft:10 }}>
                                <Text size={14} theme='h2' textAlign='left'>ADD NEW CARD ACCOUNT</Text>
                            </View>
                        </Button>
                    </View>
                
                </View>
                )
            default: return <></>
        }
    }

    return (
        <View style={{ flex:1 }}>
             
            <View style={{ flex:1 }}>
                <FlatList
                    key='account_sections'
                    data={screen_sections}
                    renderItem={renderSections}
                    keyExtractor={(item) => item}
                />
                
            </View>
            <View type='footer' style={{ flexDirection:'row', padding:20 }}>
                <Button
                    style={{ flex:1 }}
                    title={'BACK'}
                    type='close'
                    onPress={() => onClose()}
                />
            </View>
        </View>
    )
}

export default AccountManager